<dentr-modal>
  <h3 class="heading-xl mb-4" data-e2e-inactivity-modal-heading>Are you still there?</h3>
  <p class="mb-6">We've noticed that you haven't been active for a while. For your security, we'll automatically log you out in {{ counter }} seconds.</p>
  <button class="btn-primary w-full" (click)="close()">Continue</button>
</dentr-modal>
